import { useTranslation } from 'react-i18next'

import type { AccountSecurity } from '@/api'
import { SettingsRowSkeleton } from '@/components/SettingsRow'
import { SettingsSection } from '@/components/SettingsSection'

import { ConnectionRow } from './ConnectionRow'
import { useAccountConnections } from './useAccountConnections'

export const ConnectionsSection = ({ connections }: { connections: AccountSecurity['connections'] | undefined }) => {
    const { t } = useTranslation()
    const connect = useAccountConnections(connections)

    const availableConnections = connections?.filter((connection) => connection.enabled || connection.connected)

    if (availableConnections?.length === 0) {
        return null
    }

    return (
        <SettingsSection title={t('security.connections.title')} description={t('security.connections.description')}>
            {!availableConnections ? (
                <>
                    <SettingsRowSkeleton />
                    <SettingsRowSkeleton />
                </>
            ) : (
                <>
                    {availableConnections.map((connection) => (
                        <ConnectionRow
                            key={connection.provider}
                            connection={connection}
                            pending={connect.isPending && connect.variables === connection.provider}
                            disabled={connect.isPending || !connection.enabled}
                            onConnect={() => connect.mutate(connection.provider)}
                        />
                    ))}
                </>
            )}
        </SettingsSection>
    )
}
